import {useCallback} from 'react'
import styles from './index.module.scss'
import classNames from 'classnames'
interface StepContentProps {
  key: string
  label: string
  children: any //右侧渲染内容
}
interface StepPageProps {
  stepList: StepContentProps[] //步骤列表
  activeKey: string //当前步骤
  backTitle: string //返回标题
  backFun?: () => void //点击返回按钮
  hideBack?: boolean // 隐藏返回按钮
  activeStepFontColor?: string //当前步骤字体颜色
  activeStepNumColor?: string //当前步骤数字颜色
  activeStepNumBgColor?: string //当前步骤数字背景色
  className?: string
}
export const StepPage = (props: StepPageProps) => {
  const {
    stepList,
    activeKey,
    backTitle,
    hideBack = false,
    activeStepFontColor = '#040b1a',
    activeStepNumColor = '#fff',
    activeStepNumBgColor = '#ff9400',
  } = props
  const getCurrentStepInfo = () => {
    let stepInfo: StepContentProps = {
      key: '',
      label: '',
      children: '',
    }
    stepList.some((step: StepContentProps) => {
      if (step.key === props.activeKey) {
        stepInfo = step
        return true
      }
    })
    return stepInfo.children
  }

  const back = () => {
    props.backFun && props.backFun()
  }
  return (
    <div className={classNames(styles.container, props.className)}>
      <div className={styles.leftStep}>
        {
          !hideBack && <div className={styles.titleContent} onClick={back}>
            <img src="https://hd-static.yystatic.com/243966942753296.png"/>
            <div>{backTitle}</div>
          </div>
        }
        <div className={styles.stepContent}>
          {stepList.map((step, index) => {
            return (
              <div className={styles.step} key={index}>
              <div
                  className={styles.num}
                  style={{
                    backgroundColor: activeKey === step.key ? activeStepNumBgColor : '#f2f3f4',
                    color: activeKey === step.key ? activeStepNumColor : '',
                  }}
                >
                  {index + 1}
                </div>
                <div
                  style={{
                    color: activeKey === step.key ? activeStepFontColor : '',
                  }}
                >
                  {step.label}
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className={styles.rightContent}>{getCurrentStepInfo()}</div>
    </div>
  )
}
export default StepPage
